import type { Account } from '@mattoespresso/brew-firestore';

import { useContext, createContext } from 'react';

import { useManagers } from 'src/hooks/useManagers';

const ManagersContext = createContext<{
  data: Account[];
  loading: boolean;
  error: any;
}>({
  data: [],
  loading: false,
  error: null,
});

export function useManagersContext() {
  return useContext(ManagersContext);
}

export function ManagersProvider({ children }: { children: React.ReactNode }) {
  const value = useManagers();

  return <ManagersContext.Provider value={value}>{children}</ManagersContext.Provider>;
}
